<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>问题反馈</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>问题反馈</span>
        <el-divider></el-divider>
      </p>
    </div>
    <el-form ref="form" :model="form" label-width="100px" class="feedback_box">
      <el-form-item label="问题板块">
        <el-select v-model="form.nav_id" placeholder="请选择活动区域">
          <el-option-group
            v-for="group in optionList"
            :key="group.label"
            :label="group.label"
            >
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="问题描述">
        <el-input type="textarea" v-model="form.mes"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-show="subBtnOnOff" type="primary" class="rg_form_box_form_sub" @click="onSubmit">提交</el-button>
        <el-button v-show="!subBtnOnOff" type="primary" :loading="true">提交中</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      subBtnOnOff: true,
      form: {
        nav_id: '',
        mes: '',
        img: []
      },
      optionList: [ // 板块列表
        {
          label: '社区生态',
          options: [{
            value: 5,
            label: '会客厅',
            type: 'text'
          }]
        },
        {
          label: '联盟生态',
          options: [
            {
              value: 10,
              label: '研讨沙龙',
              type: 'text'
            },
            {
              value: 7,
              label: '推荐',
              type: 'text'
            },
            {
              value: 11,
              label: '培训',
              type: 'text'
            },
            {
              value: 13,
              label: '项目路演',
              type: 'live'
            },
            {
              value: 15,
              label: '论坛',
              type: 'live'
            }
          ]
        },
        {
          label: '研究院生态',
          options: [
            {
              value: 18,
              label: '研究学院',
              type: 'live'
            },
            {
              value: 20,
              label: '研究成果',
              type: 'live'
            },
            {
              value: 21,
              label: '行业手册',
              type: 'live'
            },
            {
              value: 22,
              label: '报告下载',
              type: 'live'
            },
            {
              value: 23,
              label: '出版物',
              type: 'live'
            },
            {
              value: 24,
              label: '学术交流',
              type: 'live'
            },
            {
              value: 25,
              label: '专家学者',
              type: 'live'
            }
          ]
        }
      ]
    }
  },
  methods: {
    onSubmit () {
      const vueThat = this
      vueThat.subBtnOnOff = false
      vueThat.myApi.addFeedback(vueThat.form).then(res => {
        vueThat.subBtnOnOff = true
        if (res.data.code === 200) {
          vueThat.$alert('反馈意见提交成功，谢谢您的支持！', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.form = {
                nav_id: '',
                mes: '',
                img: []
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
.feedback_box{
  margin: 30px 0;
}
</style>
